import React from 'react';
import { useToastContainer } from './ToastContainer.hook';
import { Toast } from '../Toast';
import { container } from './ToastContainer.styles';

export const ToastContainer: React.FC = () => {
  const { toasts, handleClose } = useToastContainer();

  return (
    <div className={container}>
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onClose={handleClose} />
      ))}
    </div>
  );
};

export default ToastContainer;
